export default __webpack_public_path__ + "static/media/WEG6.d9d83896.jpg";